<template>
  <div class="mycomplain-list">
    <!-- <div class="title">
      <van-nav-bar title="我的投诉">
        <van-icon name="arrow-left" slot="left" @click="Back()" />
      </van-nav-bar>
    </div> -->
    <!-- <van-loading size="24px" v-if="loadings">加载中...</van-loading> -->
    <loading v-if="loadings"></loading>
    <div class="content" v-if="ListShow">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了..." @load="onLoad" :offset="160">
        <div class="list-item" v-for="(item, index) in list" :data-type="0" :key="index" @click="skip(item)">
          <van-swipe-cell>
            <div class="list-box"></div>
            <div class="list-content">
              <div class="wrap">
                <div class="top">
                  <div class="name">投诉对象：{{ item.respondent }}</div>
                  <div class="status" v-if="item.state == '0'">
                    处理中
                    <van-icon name="arrow" slot="right" />
                  </div>
                  <div class="status" v-if="item.state == '1'">
                    处理中
                    <van-icon name="arrow" slot="right" />
                  </div>
                  <div class="status" v-if="item.state == '2'">
                    已处理
                    <van-icon name="arrow" slot="right" />
                  </div>
                  <div class="status" :style="{color:'#787878'}" v-if="item.state == '3'">
                    已撤销
                    <van-icon color="#787878" name="arrow" slot="right" />
                  </div>
                  <div class="status" v-if="item.state == '4'">
                    未通过
                    <van-icon name="arrow" slot="right" />
                  </div>
                </div>
                <div class="bottom">
                  <div class="text">投诉原因：{{ item.complaintReson }}</div>
                  <div class="time">
                    {{ item.complaintTime }}
                  </div>
                </div>
              </div>
            </div>
            <template slot="right">
              <van-button square type="danger" text="删除" @click="deleteItem(item.id, index)" />
            </template>
          </van-swipe-cell>
        </div>
      </van-list>
    </div>
    <div class="noList" v-if="!ListShow">
      <van-image :src="noListIcon" width="200px" height="200px"></van-image>
      <p>您目前还没有投诉信息</p>
    </div>
  </div>
</template>
<script>
import qs from 'qs';
import Loading from '@/components/loading';
export default {
  data() {
    return {
      value: null,
      list: [],         //列表数据源
      ListShow: true,   //是否不显示  “您还没有投诉信息”
      loadings: true,   //是否显示gif
      noListIcon: require('../../assets/img/data_empty.png'),
      loading: false, //是否处于加载状态
      finished: false,  //是否已加载完成
      pageNum: 1,    //分页请求页码
      pageSize: 6,   //分页请求数据条数
      uid: this.$cookie.get('w_uid'), //userId
      // uid: '5da6d36f61eb11018748f662',
      // uid: '', //测试id
      startX: 0,
      endX: 0,
    };
  },
  components: {
    Loading,
  },
  created() {
  },
  mounted() {
    document.title = '我的投诉';
  },
  methods: {
    // 返回上一页
    Back() {
      this.$router.go(-1);
    },
    // 上拉加载事件
    onLoad() {
      // 异步更新数据
      this.getData();
      this.pageNum = this.pageNum + 1;

    },
    //请求列表数据
    getData() {
      //显示加载状态
      this.loading = true
      this.$request
        .get(
          `/appserver/v1/complaint/queryComplainMobi?uid=${this.uid}&page=${this.pageNum}&size=${this.pageSize}`
        )
        .then((data) => {
          // console.log(data,'获取到的数据');
          if (data.data.ret == 0) {
            // delete data.data.data.list;
            if (data.data.data !== null) {
              if (data.data.data.list == null) {
                this.loadings = false;
                this.loading = false;
                this.finished = true;
                this.ListShow = false;
              } else {
                if (data.data.data.list.length == 0) {
                  this.ListShow = false;
                  this.loadings = false;
                  this.loading = false;
                  this.finished = true;
                } else {
                  this.ListShow = true;
                  this.list = this.list.concat(data.data.data.list);
                  this.loading = false;
                  if (this.list.length >= data.data.data.pagination.total) {
                    this.finished = true;
                  }
                  this.loadings = false
                  this.loading = false
                }
              }
            } else {
              this.loading = false;
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        });
    },
    //跳转
    skip(item) {
      this.$router.push({
        path: '/myComplainDetails',
        query: {
          item: JSON.stringify(item),
        },
      });
    },
    //删除
    deleteItem(id, index) {
      // 当前索引
      //let index = e.currentTarget.dataset.index;
      // 删除
      this.list.splice(index, 1);
      let data = {
        nid: id,
      };
      this.$request
        .post('/appserver/v1/complaint/deleteComplain', qs.stringify(data))
        .then((data) => {
          if (data.data.ret === 0) {
            // console.log(this.list.length,'this.list.length');
            // 全部删除完
            if (this.list.length === 0) {
              this.ListShow = false;
              this.loadings = false;
              this.loading = false;
              this.finished = true;
            }
            //  this.pageNum = 0;
            //  this.loading = true;
            //   this.loadings = true
            // this.list=[]
            // this.onLoad();
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.mycomplain-list {
  font-size: 14px;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 100%;
  /deep/ .van-loading {
    padding-top: 20px;
    text-align: center;
  }
  .header {
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: #fff;
    z-index: 1200;
    /deep/ .van-icon {
      color: #000;
      font-size: 20px;
    }
    /deep/ .van-hairline--bottom::after {
      border: 0px;
    }
  }
  .content {
    overflow-y: auto;

    background: #f8f8f8;
    padding: 20px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    .list-item {
      margin-bottom: 20px;
      .list-content {
        background: #fff;
        padding: 16px;
        .wrap {
          .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 3px 0px 18px 0px;
            border-bottom: 1px solid #E8E8E8;
            .name {
              width: 70%;
              font-size: 14px;
              font-family: PingFang-SC-Bold, PingFang-SC;
              font-weight: bold;
              color: rgba(55, 56, 77, 1);
              line-height: 20px;
              height: 20px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
            }
            .status {
              height: 12px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #2EBA73;
              line-height: 12px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              /deep/ .van-icon {
                margin-left: 14px;
                font-size: 16px;
              }
            }
          }
          .bottom {
            margin-top: 16px;
            .text {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(85, 89, 89, 1);
              line-height: 24px;
            }
            .time {
              margin-top: 16px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 12px;
            }
          }
        }
      }
      /deep/ .van-button {
        height: 100%;
        width: 74px;
        border: 0px;
        background: rgba(255, 114, 95, 1);
        border-radius: 0px 2px 2px 0px;
      }
      /deep/ .van-button span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .noList {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    background: #f8f8f8;
    p {
      width: 100%;
      text-align: center;
      color: #999;
      font-size: 12px;
    }
  }
}
</style>
